/**
 * Build-time feature flag for the procedural media library additions to the
 * Wallpaper picker: animated Loops, SVG wallpaper Designs, and Preset image
 * wallpapers (each ported from the deck's procedural sources — DL-063b/c + WP-IMG).
 *
 * Additive + inert by default: while OFF, none of the Loops / Designs / Presets
 * categories are added to the Wallpaper picker, so behaviour is byte-identical to
 * today. Flip per environment via REACT_APP_PROCEDURAL_LIBRARY (staging sets "true").
 *
 * Mirrors the repo's featureFlag.js convention (CloneLineage/LinkedWheels/…).
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const PROCEDURAL_LIBRARY_ENABLED = truthy(
  process.env.REACT_APP_PROCEDURAL_LIBRARY
);
